import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AlertService } from "app/core/alert/alert.service";

@Component({
    selector: "upload-file",
    templateUrl: "upload-file.component.html",
    standalone: false
})
export class UploadFileComponent {
  @Input() label = "Adicionar anexo";
  @Input() acceptFiles = [
    "xls",
    "xlsx",
    "odt",
    "ods",
    "txt",
    "p7s",
    "jpg",
    "jpeg",
    "png",
    "gif",
    "html",
    "htm",
    "mp3",
    "aac",
    "wav",
    "vorbis",
    "mp4",
    "avi",
    "mpeg",
    "ogg",
    "opus",
    "quicktime",
    "wmv",
    "pdf",
    "zip",
    "webm",
  ].map(f => '.' + f).join(', ');

  @Input() sizeClass = "w-32 min-h-32 h-full";

  @Input() maxSize = 30;


  @Output() newFile = new EventEmitter<File>();

  maxSizeCalc = this.maxSize * 1024 * 1024;

  constructor(
    private _alert: AlertService,
  ) {}

  handleFileInput(files: FileList) {
    if (files.item(0).size > this.maxSizeCalc) {
      this._alert.error(`Atenção, o arquivo excede o limite de tamanho de ${this.maxSize}mb.`);
      return;
    }
    
    this.newFile.emit(files.item(0));
  }
}
